// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__37tJH","dots":"styles_dots__3aOs_"};